import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#fff'
        d='M8.277 3.333H14a.667.667 0 01.666.667v9.333a.667.667 0 01-.666.667H2a.666.666 0 01-.667-.667V2.667A.667.667 0 012.001 2h4.942l1.334 1.333zm-5.61 0v9.334h10.667v-8h-5.61L6.392 3.333H2.667zM7.334 6h1.333v5.333H7.334V6zm2.667 2h1.333v3.333h-1.333V8zM4.667 9.333h1.334v2H4.667v-2z'
      ></path>
    </svg>
  )
}

export default Icon
